import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from '../../../utils';
import type {
  GetCompanyCodeTranslationQuery,
  GetCompanyCodeTranslationQueryVariables,
  CreateCompanyCodeTranslationInput,
  CreateCompanyCodeTranslationMutation,
} from '../../../graphql';
import { createCompanyCodeTranslation, getCompanyCodeTranslation } from '../../../graphql';
import { RTK_CACHE_LIFETIME } from '../../../config';
import type { TDSOptions } from '../types';

export const companyCodeTranslationApi = createApi({
  reducerPath: 'companyCodeTranslationApi',
  baseQuery: baseQuery,
  tagTypes: ['companyCodeTranslation'],
  endpoints: (builder) => ({
    getTDSOptions: builder.query<TDSOptions[], GetCompanyCodeTranslationQueryVariables>({
      query: (variables) => ({ body: getCompanyCodeTranslation, variables }),
      keepUnusedDataFor: RTK_CACHE_LIFETIME,
      providesTags: ['companyCodeTranslation'],
      transformResponse: (response: GetCompanyCodeTranslationQuery, m, variables) => {
        if (variables?.codetype === '1') {
          // tds
          return (
            response?.getCompanyCodeTranslation?.map((item) => {
              const cv = item?.codevalue;
              const percentage =
                cv === null || cv === undefined || cv === ''
                  ? ''
                  : (() => {
                      const n = Number(cv);
                      return Number.isFinite(n) ? String(n) : '';
                    })();
              return {
                label: item?.codetext || '',
                // Some newly-created rows may have empty `section` initially; use codeorder fallback.
                value: item?.section || (item?.codeorder != null ? String(item.codeorder) : ''),
                percentage,
                codeorder: item?.codeorder ?? undefined,
              };
            }) || []
          );
        }
        return [];
      },
    }),
    createCompanyCodeTranslation: builder.mutation<CreateCompanyCodeTranslationMutation, CreateCompanyCodeTranslationInput>({
      query: (variables) => ({
        body: createCompanyCodeTranslation,
        variables,
      }),
      invalidatesTags: ['companyCodeTranslation'],
    }),
  }),
});
export const { useGetTDSOptionsQuery, useLazyGetTDSOptionsQuery, usePrefetch, useCreateCompanyCodeTranslationMutation } =
  companyCodeTranslationApi;
